import { Inventory } from "./inventory";
import { ImageFit, ImageFrame } from "../shared/listing-image/listing-image.model";

export class PropertyImage{
    
    public id?:number;
    public reference!:string;
    public sequenceNo!:number;
    public frame:ImageFrame|null=null; //listing frame (relative), null = whole image centered
    public fit:ImageFit='cover';
    public fromInventory?:Inventory; //only used when transferring an image from inventory as they come from a non-public bucket => different api call
    
    constructor(){

    }
}
